import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Button, Form, FormGroup, Label, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { fetchEmployeeDropdown, fetchActiveEmployees, getpayEmpReport, clearGetpayEmpReportList } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import * as Yup from "yup";
import Select from "react-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainerColumnTotal from "components/Common/TableContainerColumnTotal";
import CustomMonthPicker from "common/CustomMonthPicker";
import CustomSelect from "components/Common/custom-select";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { orderBy } from "lodash";
import TableContainer from "../../../../components/Common/TableContainer";
import Swal from 'sweetalert2';
// import "../../Reports/EmployeeReports/employeereports.css"

const empStatusOptions = [
  { label: "Active", value: "1" },
  { label: "Resigned", value: "2" },
];

const PayrollEmployeeReports = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);

  const {
    dropdownData,
    employees,
    payEmpReportList,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    dropdownData: state.EmployeeDetailsReducer?.dropdownData ?? {},
    employees: state.EmployeeDetailsReducer?.employeesActiveList ?? [],
    monthlyESIList: state.PayrollReportsReducer?.monthlyESIList ?? [],
    payEmpReportList: state.PayrollReportsReducer?.payEmpReportList ?? [],
    loading: state.PayrollReportsReducer?.loading,
    error: state.PayrollReportsReducer?.error,
    success: state.PayrollReportsReducer?.success,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0]?.unit_id
    dispatch(fetchEmployeeDropdown(unitId));
    dispatch(fetchActiveEmployees(unitId));
  }, [dispatch]);

  const categoryOptions = dropdownData?.category_list?.map((item) => ({ label: item.category_name, value: item.category_id, })) || [];
  const departmentOptions = dropdownData?.department_list?.map((item) => ({ label: item.depart_name, value: item.depart_id, })) || [];
  const designationOptions = dropdownData?.designation_list?.map((item) => ({ label: item.desig_name, value: item.desig_id, })) || [];

  const formik = useFormik({
    initialValues: {
      category: "0",
      department: "0",
      designation: "0",
      employee: "",
      employeesActiveList: [],
      loading: false,
      error: null,
      success: false,
      dropdownData: {},
      empStatus: "1",
    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("Opt", 1);
      formData.append("unit_id", authDetails?.unit_id || 0);
      formData.append("emp_cat", values.category || 0);
      formData.append("emp_dep", values.department || 0);
      formData.append("designation", values.designation || 0);
      formData.append("emp_code", values.employee);
      formData.append("emp_status", values.empStatus)
      dispatch(getpayEmpReport(formData));
    },
  });

  const columns = [
    { Header: "S No", Cell: ({ row }) => payEmpReportList.length - row.index, width: 70, className: "text-center", headerClassName: "text-center" },
    { Header: "EMPLOYEE CODE", accessor: "emp_no", width: 130 },
    { Header: "EMPLOYEE NAME", accessor: "emp_name", minWidth: 200 },
    { Header: "GENDER", accessor: "Gender", width: 90, className: "text-center" },
    { Header: "PHYSICALLY CHALLENGED", accessor: "phy_challenged_not", minWidth: 170 },
    { Header: "DESIGNATION", accessor: "designation", minWidth: 160 },
    { Header: "DEPARTMENT", accessor: "dept", minWidth: 160 },
    { Header: "DOB", accessor: "dob", width: 120, className: "text-center" },
    { Header: "AGE", accessor: "age", width: 80, className: "text-center" },
    { Header: "DOJ", accessor: "join_dt", width: 120, className: "text-center" },
    { Header: "EXPERIENCE", accessor: "exp", width: 110, className: "text-center" },
    { Header: "LEVELS", accessor: "level", width: 90 },
    { Header: "GRADE", accessor: "grade", width: 90 },
    { Header: "PACODE", accessor: "psCode", width: 120 },
    { Header: "GROSS", accessor: "Gross", width: 120, className: "text-center" },
    { Header: "EPF", accessor: "epf_no", minWidth: 160, className: "text-center" },
    { Header: "ESI", accessor: "esi_no", minWidth: 160, className: "text-center" }
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Payroll / Reports" breadcrumbItem="Employee Reports" />
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label>Category</Label>
                    <Select
                      options={categoryOptions}
                      name="category"
                      value={categoryOptions.find((opt) => opt.value === formik.values.category) || null}
                      onChange={(selected) => formik.setFieldValue("category", selected ? selected.value : "")}
                      placeholder="Select"
                    />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <Label>Department</Label>
                    <Select
                      options={departmentOptions}
                      name="department"
                      value={departmentOptions.find((opt) => opt.value === formik.values.department) || 0}
                      onChange={(selected) => formik.setFieldValue("department", selected ? selected.value : 0)}
                      placeholder="Select"
                    />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <Label>Designation</Label>
                    <Select
                      options={designationOptions}
                      name="designation"
                      value={designationOptions.find((opt) => opt.value === formik.values.designation) || null}
                      onChange={(selected) => formik.setFieldValue("designation", selected ? selected.value : "")}
                      placeholder="Select"
                    />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <Label>Employee Code</Label>
                    <CustomSelect
                      id="employee"
                      name="employee"
                      isMulti={false}
                      options={employees || []}
                      value={employees?.find(opt => opt.value === formik.values.employee) || null}
                      onChange={(selectedOption) =>
                        formik.setFieldValue("employee", selectedOption ? selectedOption.value : "")
                      }
                      onBlur={() => formik.setFieldTouched("employee", true)}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isClearable={true}
                    />
                  </FormGroup>
                </Col>

                <Col md={4} className="d-flex align-items-center">
                  <FormGroup className="mb-0 me-4 chk-bx-label">
                    <Label className="me-2 w-100">Emp Status</Label>
                    {empStatusOptions.map(option => (
                      <div key={option.value} className="form-check form-check-inline d-flex align-items-center gap-2">
                        <Input
                          className="form-check-input"
                          type="radio"
                          name="empStatus"
                          value={option.value}
                          checked={formik.values.empStatus === option.value}
                          onChange={formik.handleChange}
                        />
                        <Label className="form-check-label d-flex align-items-center gap-2">
                          {option.label}
                        </Label>
                      </div>
                    ))}
                  </FormGroup>
                </Col>

                <Col className="d-flex align-items-end justify-content-end">
                  <Button type="submit" className="btn button-search me-2"> <i className="fas fa-search me-1" /> Search</Button>
                  {payEmpReportList && payEmpReportList.length > 0 && (
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export me-2 ms-2"> <i className="fas fa-file-export me-1" /> Export</DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(payEmpReportList, authDetails?.unit_fullname, authDetails?.unit_address, "Section Wage Register Report")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>
                        <DropdownItem onClick={() => exportEmployeeToPDF(payEmpReportList, authDetails?.unit_fullname, authDetails?.unit_address, "Section Wage Register Report", columns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}
                  <Button type="reset" className="btn button-cancel ms-2"
                    onClick={() => {
                      Swal.fire({
                        title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                        showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                      }).then((result) => {
                        if (result.isConfirmed) {
                          formik.handleReset();
                          dispatch(clearGetpayEmpReportList());
                        }
                      });
                    }}
                  >
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <TableContainer columns={columns} data={payEmpReportList || []} isGlobalFilter={true} customPageSize={10} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PayrollEmployeeReports;
